import AuthorsApi from '@/frontend/api/authors';
export default {
  name: "AuthorsByPeriodComponent",
  props: {
    search: String
  },

  data() {
    return {
      AuthorPeriods: []
    };
  },

  computed: {
    rows() {
      let rows = [],
          i;

      for (let period in this.filteredAuthors) {
        let record = {};
        i = 0;
        record.period = period;
        record.cols = [];
        this.filteredAuthors[period].forEach(item => {
          if (!Array.isArray(record.cols[i])) record.cols[i] = [];
          record.cols[i].push(item);
          if (i === 2) i = 0;else i += 1;
        });
        rows.push(record);
      }

      rows.sort((a, b) => {
        let aYear = parseInt(a['period'].match(/\d+/)),
            bYear = parseInt(b['period'].match(/\d+/));
        if (aYear < bYear) return -1;
        if (aYear > bYear) return 1;
        return 0;
      });
      return rows;
    },

    filteredAuthors() {
      let result = {};
      if (!this.AuthorPeriods.length) return result;
      this.AuthorPeriods.forEach(item => {
        let period = item.year;

        if (!this.search || item.name.toUpperCase().indexOf(this.search.toUpperCase()) !== -1) {
          if (!Array.isArray(result[period])) result[period] = [];
          result[period].push({
            id: item.id,
            name: item.name
          });
        }
      });
      return result;
    }

  },

  created() {
    AuthorsApi.getPeriods().then(response => this.AuthorPeriods = Object.values(response));
  }

};